import type Account from '@/features/account/application/domain/entities/account';

/**
 * Whether the selected account has the Reports tab turned on (VTK-2166): a per-account flag from
 * core. Anything but an explicit `true` is off, so an account persisted before the field existed
 * keeps the tab hidden rather than showing it.
 */
export const reportsEnabledFor = (account: Pick<Account, 'reportsEnabled'> | null | undefined) =>
  account?.reportsEnabled === true;
